// components/DisclaimerModal.jsx
import React from 'react';
import useStockStore from '../../../stores/useStockStore';

const DisclaimerModal = ({ onCancel, onAgree }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center px-4">
      <div className="bg-gray-900 text-white max-w-3xl w-full rounded-xl p-6 shadow-xl border border-purple-600">
        <h2 className="text-2xl font-bold mb-4 text-center">Automated Trading Disclaimer and Waiver of Liability</h2>

        <div className="max-h-96 overflow-y-auto bg-gray-800 p-4 rounded-lg text-sm leading-relaxed space-y-2">
          <p><strong>WARNING:</strong> Algorithmic trading is inherently risky. You should NOT use JTNCBot unless you fully understand and accept these risks. By continuing, you acknowledge that you are fully aware of these risks and accept full responsibility for any and all outcomes.</p>
          
          <p>Automated trading involves both known and unknown risks...</p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li><strong>User Responsibility for Configuration:</strong> You are solely responsible for configuring JTNCBot's automation tools...</li>
            <li><strong>Understanding Algorithm Behavior:</strong> By using JTNCBot's automated trading features...</li>
            <li><strong>Market Risk & Volatility:</strong> JTNCBot's tools do not mitigate or protect against market risk...</li>
            <li><strong>Third-Party Data & Broker Integration:</strong> JTNCBot relies on third-party brokers...</li>
            <li><strong>Execution Delays or Failures:</strong> JTNCBot does not guarantee the timely execution of trades...</li>
          </ul>
        </div>

        <p className="text-xs text-gray-400 mt-4">
          By clicking "Agree" below, you acknowledge that you have read, understood, and accepted all terms of this disclaimer.
        </p>

        <div className="flex justify-end mt-6 space-x-2">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-700 rounded hover:bg-gray-600">
            I do not agree
          </button>
          <button onClick={onAgree} className="px-4 py-2 bg-purple-600 rounded hover:bg-purple-500">
            I agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;